export enum CodigosSubfeatureVars {
    ACTIVAR_FLUJO_INVERSIONES_OFFLINE = 'ACTIVAR_FLUJO_INVERSIONES_OFFLINE'
}

export enum TipoUsuario {
    EJECUTIVO = 'Ejecutivo',
    EMPRESA = 'Empresa',
    PERSONA = 'Persona'
  }
  
  export enum MdbCollections {
    INVERSION_FONDOS_MUTUOS = 'inversion-fondos-mutuos',
  }
  
  export enum DestinoLogs {
    MDB = 'MDB',
  }
  
  